import {REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {
  GENERATE_CC_FROM_FILE_AGENCIES_READ,
  GENERATE_CC_FROM_FILE_CC_ARTEFACT_SET,
  GENERATE_CC_FROM_FILE_CC_ARTEFACT_TYPE_SET,
  GENERATE_CC_FROM_FILE_CC_ARTEFACTS_HIDE,
  GENERATE_CC_FROM_FILE_CC_ARTEFACTS_READ,
  GENERATE_CC_FROM_FILE_CC_CHANGE,
  GENERATE_CC_FROM_FILE_CC_RESET,
  GENERATE_CC_FROM_FILE_CC_SUBMIT,
  GENERATE_CC_FROM_FILE_CSV_ROWS_HIDE,
  GENERATE_CC_FROM_FILE_CSV_ROWS_READ,
  GENERATE_CC_FROM_FILE_CSV_ROWS_SHOW,
  GENERATE_CC_FROM_FILE_FILE_FORM_CHANGE,
  GENERATE_CC_FROM_FILE_FILE_UPLOAD
} from "./actions";
import _ from "lodash";
import {getArtefactFromSdmxJsonStructure, getSdmxStructuresFromSdmxJson} from "../../../utils/sdmxJson";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";

const fileFormDefault = {
  file: null,
  separator: ";",
  delimiter: null
};

const generateCCFromFileReducer = (
  state = {
    agencies: null,
    contentConstraint: null,
    artefactType: null,
    artefacts: null,
    artefact: null,
    fileForm: fileFormDefault,
    filePath: null,
    isPreviewVisible: false,
    csvRows: null
  },
  action
) => {
  switch (action.type) {
    case GENERATE_CC_FROM_FILE_CC_CHANGE:
      const contentConstraint = _.cloneDeep(state.contentConstraint);
      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };
      return {
        ...state,
        contentConstraint: _.mergeWith(contentConstraint, action.fields, customizer)
      };
    case GENERATE_CC_FROM_FILE_CC_RESET:
      return {
        ...state,
        contentConstraint: null,
        artefactType: null,
        artefacts: null,
        artefact: null,
        fileForm: fileFormDefault,
        filePath: null
      };
    case GENERATE_CC_FROM_FILE_CC_ARTEFACT_TYPE_SET:
      return {
        ...state,
        artefactType: action.artefactType,
        artefacts: null,
        artefact: null
      };
    case GENERATE_CC_FROM_FILE_CC_ARTEFACTS_HIDE:
      return {
        ...state,
        artefacts: null
      };
    case GENERATE_CC_FROM_FILE_CC_ARTEFACT_SET:
      return {
        ...state,
        artefacts: null,
        artefact: action.artefact
      };
    case GENERATE_CC_FROM_FILE_FILE_FORM_CHANGE:
      return {
        ...state,
        fileForm: _.mergeWith(state.fileForm, action.fields),
        filePath: null
      };
    case GENERATE_CC_FROM_FILE_CSV_ROWS_SHOW:
      return {
        ...state,
        isPreviewVisible: true,
        csvRows: null
      };
    case GENERATE_CC_FROM_FILE_CSV_ROWS_HIDE:
      return {
        ...state,
        isPreviewVisible: false,
        csvRows: null
      };
    case REQUEST_SUCCESS:
      switch (action.label) {
        case GENERATE_CC_FROM_FILE_AGENCIES_READ:
          return {
            ...state,
            agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID))
          }
        case GENERATE_CC_FROM_FILE_CC_SUBMIT:
          return {
            ...state,
            contentConstraint: null,
            artefactType: null,
            artefacts: null,
            artefact: null,
            fileForm: fileFormDefault,
            filePath: null
          }
        case GENERATE_CC_FROM_FILE_CC_ARTEFACTS_READ:
          return {
            ...state,
            artefacts: (getSdmxStructuresFromSdmxJson(action.response) || [])
              .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          }
        case GENERATE_CC_FROM_FILE_FILE_UPLOAD:
          return {
            ...state,
            filePath: action.response
          }
        case GENERATE_CC_FROM_FILE_CSV_ROWS_READ:
          return {
            ...state,
            csvRows: action.response
          }
        default:
          return state;
      }
    default:
      return state;
  }
};

export default generateCCFromFileReducer;